import { Breadcrumb, Card, Divider, Typography } from "antd";

import useStyles from './styles';
import { ProCard } from "@ant-design/pro-components";
import { useTranslation } from "react-i18next";
import { TopBreadcrumb } from "./TopBreadcrumb";
import { useResourceParams } from "@refinedev/core";

export const CreationWrapper = ({
  i18nTitle,
  title: titleFromProps,
  footer,
  children,
  desc,
}) => {
  const { t } = useTranslation();
  const { styles, } = useStyles();
  const { action } = useResourceParams();

  const renderFooter = () => {
    if (typeof footer === 'function') {
      return footer();
    }
    return footer;
  }
  let title = '';
  if (i18nTitle) {
    title = t(i18nTitle, titleFromProps);
  } else if (titleFromProps) {
    title = titleFromProps;
  } else {
    title = t(`actions.${action}`);
  }

  return <div className={styles.configPage}>
    <TopBreadcrumb />
    <ProCard split="vertical" style={{ marginTop: 20 }}>
      <ProCard title={<div style={{ fontSize: 18, fontWeight: 500 }}>{title}</div>} headerBordered colSpan="70%">
        {children}
        <Divider />
        {renderFooter()}
      </ProCard>
      <ProCard title={<div style={{ fontSize: 18, fontWeight: 500 }}>Info</div>} colSpan="30%" headerBordered>
        {desc || <Typography.Text type="secondary">No description</Typography.Text>}
      </ProCard>
    </ProCard>
  </div>;
};